import {v3} from "./v3";
export type BasisVectors = {
    normal: number[],
    origin: number[],
    right: number[]
}

export const dimensionTransformation = {
    to2dPlanePoint: (pos: number[], basis: BasisVectors) => {
        const up = v3.normalize(v3.crossVectors(basis.normal, basis.right))
        const proj = v3.projectOnPlane(pos, basis.normal);
        const d = v3.subVectors(proj, basis.origin);
        const u = v3.dotVectors(d, basis.right);
        const v = v3.dotVectors(d, up);
        return [u,v];
    },
    to3dPoint: (pos: number[], basis: BasisVectors) => {
        const up = v3.normalize(v3.crossVectors(basis.normal, basis.right))
        const r = v3.addScaledVector(basis.origin, basis.right, pos[0]);
        const u = v3.addScaledVector(basis.origin, up, pos[1]);
        return v3.addVectors(r, u);
    }
}
